import React, { useEffect, useState } from 'react';
import { Box, Button, Icon } from '@mui/material';
import moment from 'moment-timezone';
import { IEtfValue, useGetEtfsWithValuesLazyQuery } from '../../generated/graphql';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { Colors } from '../../utils/theme';
import OverviewTable from '../Common/Tables/OverviewTable';
import { renderDateString } from '../../utils/styleUtils';
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import EpraDatePicker from '../Common/Fields/EpraDatePicker';
import { iconStyle } from '../../utils/styleUtils';
interface IProps {
  indexOfActiveTab: number;
}
const dateFormat = 'dd/MM/yyyy';
const EtfValuesList: React.FunctionComponent<IProps> = ({ indexOfActiveTab }: IProps) => {
  const navigate = useNavigate();
  const [date, setDate] = useState<Date | null>(null);
  const [getEtfValues, { data, loading }] = useGetEtfsWithValuesLazyQuery({
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    getEtfValues();
  }, []);

  useEffect(() => {
    if (date) {
      getEtfValues({
        variables: {
          date: moment(date).format('YYYY-MM-DD')
        }
      });
    } else {
      getEtfValues();
    }
  }, [date]);

  const formatDate = (rowData: IEtfValue, name: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return rowData[name] ? renderDateString(rowData[name]) : '';
  };

  const renderHistoryColumn = (rowData: IEtfValue) => (
    <Button id={rowData.id} onClick={() => handleHistory(rowData)}>
      <Icon sx={{ ...iconStyle, color: Colors.skyBlue }}>history</Icon>
    </Button>
  );

  const columns = [
    {
      title: 'Details',
      width: 60,
      sorting: false
    },
    {
      title: 'History',
      width: 60,
      sorting: false,
      render: renderHistoryColumn
    },
    {
      title: 'Date',
      field: 'date',
      width: 97,
      type: 'date',
      render: (rowData: IEtfValue) => formatDate(rowData, 'date')
    },
    {
      title: 'Provider',
      field: 'etf.provider',
      width: 101
    },
    {
      title: 'Name',
      field: 'etf.name',
      width: 273
    },
    {
      title: 'Benchmark name',
      field: 'etf.identifier',
      width: 273
    },
    {
      title: 'AUM(min)USD',
      field: 'aum',
      width: 120
    },
    {
      title: 'ETF 1yr total return %',
      field: 'total_return_one_year',
      width: 175
    },
    {
      title: 'Index 1 yr total return %',
      field: 'index_total_return_one_year',
      width: 180
    },
    {
      title: 'ETF 3 yr total return %',
      field: 'total_return_three_year',
      width: 175
    },
    {
      title: 'Index 3 yr total return %',
      field: 'index_total_return_three_year',
      width: 180
    }
  ];

  const handleHistory = (rowData: IEtfValue) => {
    navigate(`/etfs/${rowData.etf.id}`, {
      state: { ...rowData.etf, indexOfActiveTab }
    });
  };

  return (
    <Box className="overviewPage">
      <Box className="print\:w-full">
        <OverviewTable
          columns={columns as []}
          data={data?.result || []}
          loading={loading}
          handleDetails={() => true}
          handleRemove={() => null}
          pageSize={15}
          additionalFilters={
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <EpraDatePicker
                id="etf-values-date-picker"
                label="Date"
                value={date}
                clearable={true}
                onChange={(value) => setDate(value)}
                format={dateFormat}
              />
            </LocalizationProvider>
          }
        />
      </Box>
    </Box>
  );
};

export default EtfValuesList;
